import React from 'react'
import { Link } from 'react-router-dom'
import { formatMs } from '../utils/time'
import '../scss/CompeticionList.css'

const CompeticionList = (props) => (
  <ul className={'competicion-list'}>
    {props.competiciones.map(competicion => (
      <li key={competicion.id}>
        <Link to={`/competicion/${competicion.id}`} className={'competicion-list__item'}>
          {competicion.nombre}
          <div className={'competicion-list__item-guntime'}>
            Salida a las {formatMs(competicion.hora_inicio)}
          </div>
        </Link>
      </li>
    ))}
  </ul>
)

export default CompeticionList



// WEBPACK FOOTER //
// ./src/components/CompeticionList.js